!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e || self).virtualScroll = t();
}(this, function () {
  var e = 0;
  function t(t) {
    return "__private_" + e++ + "_" + t;
  }
  function i(e, t) {
    if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
  }
  function n() {}
  n.prototype = {
    on: function (e, t, i) {
      var n = this.e || (this.e = {});
      return (n[e] || (n[e] = [])).push({
        fn: t,
        ctx: i
      }), this;
    },
    once: function (e, t, i) {
      var n = this;
      function o() {
        n.off(e, o), t.apply(i, arguments);
      }
      return o._ = t, this.on(e, o, i);
    },
    emit: function (e) {
      for (var t = [].slice.call(arguments, 1), i = ((this.e || (this.e = {}))[e] || []).slice(), n = 0, o = i.length; n < o; n++) i[n].fn.apply(i[n].ctx, t);
      return this;
    },
    off: function (e, t) {
      var i = this.e || (this.e = {}),
        n = i[e],
        o = [];
      if (n && t) for (var s = 0, h = n.length; s < h; s++) n[s].fn !== t && n[s].fn._ !== t && o.push(n[s]);
      return o.length ? i[e] = o : delete i[e], this;
    }
  };
  var o = n;
  o.TinyEmitter = n;
  var s,
    h = "virtualscroll",
    r = t("options"),
    a = t("el"),
    l = t("emitter"),
    u = t("event"),
    c = t("touchStart"),
    d = t("bodyTouchAction");
  return function () {
    function e(e) {
      var t = this;
      Object.defineProperty(this, r, {
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, a, {
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, l, {
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, u, {
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, c, {
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, d, {
        writable: !0,
        value: void 0
      }), this._onWheel = function (e) {
        var n = i(t, r)[r],
          o = i(t, u)[u];
        o.deltaX = e.wheelDeltaX || -1 * e.deltaX, o.deltaY = e.wheelDeltaY || -1 * e.deltaY, s.isFirefox && 1 === e.deltaMode && (o.deltaX *= n.firefoxMultiplier, o.deltaY *= n.firefoxMultiplier), o.deltaX *= n.mouseMultiplier, o.deltaY *= n.mouseMultiplier, t._notify(e);
      }, this._onMouseWheel = function (e) {
        var n = i(t, u)[u];
        n.deltaX = e.wheelDeltaX ? e.wheelDeltaX : 0, n.deltaY = e.wheelDeltaY ? e.wheelDeltaY : e.wheelDelta, t._notify(e);
      }, this._onTouchStart = function (e) {
        var n = e.targetTouches ? e.targetTouches[0] : e;
        i(t, c)[c].x = n.pageX, i(t, c)[c].y = n.pageY;
      }, this._onTouchMove = function (e) {
        var n = i(t, r)[r];
        n.preventTouch && !e.target.classList.contains(n.unpreventTouchClass) && e.preventDefault();
        var o = i(t, u)[u],
          s = e.targetTouches ? e.targetTouches[0] : e;
        o.deltaX = (s.pageX - i(t, c)[c].x) * n.touchMultiplier, o.deltaY = (s.pageY - i(t, c)[c].y) * n.touchMultiplier, i(t, c)[c].x = s.pageX, i(t, c)[c].y = s.pageY, t._notify(e);
      }, this._onKeyDown = function (e) {
        var n = i(t, u)[u];
        n.deltaX = n.deltaY = 0;
        var o = window.innerHeight - 40;
        switch (e.keyCode) {
          case 37:
          case 38:
            n.deltaY = i(t, r)[r].keyStep;
            break;
          case 39:
          case 40:
            n.deltaY = -i(t, r)[r].keyStep;
            break;
          case 32:
            n.deltaY = o * (e.shiftKey ? 1 : -1);
            break;
          default:
            return;
        }
        t._notify(e);
      }, i(this, a)[a] = window, e && e.el && (i(this, a)[a] = e.el, delete e.el), s || (s = {
        hasWheelEvent: "onwheel" in document,
        hasMouseWheelEvent: "onmousewheel" in document,
        hasTouch: "ontouchstart" in document,
        hasTouchWin: navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1,
        hasPointer: !!window.navigator.msPointerEnabled,
        hasKeyDown: "onkeydown" in document,
        isFirefox: navigator.userAgent.indexOf("Firefox") > -1
      }), i(this, r)[r] = Object.assign({
        mouseMultiplier: 1,
        touchMultiplier: 2,
        firefoxMultiplier: 15,
        keyStep: 120,
        preventTouch: !1,
        unpreventTouchClass: "vs-touchmove-allowed",
        useKeyboard: !0,
        useTouch: !0
      }, e), i(this, l)[l] = new o(), i(this, u)[u] = {
        y: 0,
        x: 0,
        deltaX: 0,
        deltaY: 0
      }, i(this, c)[c] = {
        x: null,
        y: null
      }, i(this, d)[d] = null, void 0 !== i(this, r)[r].passive && (this.listenerOptions = {
        passive: i(this, r)[r].passive
      });
    }
    var t = e.prototype;
    return t._notify = function (e) {
      var t = i(this, u)[u];
      t.x += t.deltaX, t.y += t.deltaY, i(this, l)[l].emit(h, {
        x: t.x,
        y: t.y,
        deltaX: t.deltaX,
        deltaY: t.deltaY,
        originalEvent: e
      });
    }, t._bind = function () {
      s.hasWheelEvent && i(this, a)[a].addEventListener("wheel", this._onWheel, this.listenerOptions), s.hasMouseWheelEvent && i(this, a)[a].addEventListener("mousewheel", this._onMouseWheel, this.listenerOptions), s.hasTouch && i(this, r)[r].useTouch && (i(this, a)[a].addEventListener("touchstart", this._onTouchStart, this.listenerOptions), i(this, a)[a].addEventListener("touchmove", this._onTouchMove, this.listenerOptions)), s.hasPointer && s.hasTouchWin && (i(this, d)[d] = document.body.style.msTouchAction, document.body.style.msTouchAction = "none", i(this, a)[a].addEventListener("MSPointerDown", this._onTouchStart, !0), i(this, a)[a].addEventListener("MSPointerMove", this._onTouchMove, !0)), s.hasKeyDown && i(this, r)[r].useKeyboard && document.addEventListener("keydown", this._onKeyDown);
    }, t._unbind = function () {
      s.hasWheelEvent && i(this, a)[a].removeEventListener("wheel", this._onWheel), s.hasMouseWheelEvent && i(this, a)[a].removeEventListener("mousewheel", this._onMouseWheel), s.hasTouch && (i(this, a)[a].removeEventListener("touchstart", this._onTouchStart), i(this, a)[a].removeEventListener("touchmove", this._onTouchMove)), s.hasPointer && s.hasTouchWin && (document.body.style.msTouchAction = i(this, d)[d], i(this, a)[a].removeEventListener("MSPointerDown", this._onTouchStart, !0), i(this, a)[a].removeEventListener("MSPointerMove", this._onTouchMove, !0)), s.hasKeyDown && i(this, r)[r].useKeyboard && document.removeEventListener("keydown", this._onKeyDown);
    }, t.on = function (e, t) {
      i(this, l)[l].on(h, e, t);
      var n = i(this, l)[l].e;
      n && n[h] && 1 === n[h].length && this._bind();
    }, t.off = function (e, t) {
      i(this, l)[l].off(h, e, t);
      var n = i(this, l)[l].e;
      (!n[h] || n[h].length <= 0) && this._unbind();
    }, t.destroy = function () {
      i(this, l)[l].off(), this._unbind();
    }, e;
  }();
});